/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CreateCallbackForRoadsideAssistanceCase$Params {

/**
 * Id of a resource.
 */
  id: string;
}

export function createCallbackForRoadsideAssistanceCase(http: HttpClient, rootUrl: string, params: CreateCallbackForRoadsideAssistanceCase$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createCallbackForRoadsideAssistanceCase.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createCallbackForRoadsideAssistanceCase.PATH = '/api/v1/extensions/tenants/oeamtc/cases/{id}/callback';
